import { render, staticRenderFns } from "./AnnualLeaveType.vue?vue&type=template&id=67ef9f54&"
import script from "./AnnualLeaveType.vue?vue&type=script&lang=js&"
export * from "./AnnualLeaveType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports